module.exports = __webpack_public_path__ + "img/DSC05526-min.8207c386.jpg";